import {
  Tabs,
  Input,
  Row,
  Col,
  Card,
  Tag,
  Dropdown,
  Button,
  Space,
} from "antd";
import { MoreOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import ReactGA from "react-ga4";
import "./CategoryCard.css";

const ProductCategoryCard = ({ category, onClick }) => {
  const statusColors = {
    Available: "green",
    Disabled: "orange",
  };

  const navigate = useNavigate();

  const handleCardClick = () => {
    // Save scroll position before navigation
    const scrollY = window.pageYOffset || document.documentElement.scrollTop;
    sessionStorage.setItem("categoryListScroll", scrollY.toString());

    // Set category ID in session storage
    sessionStorage.setItem("CategoryID", category.ProductCategoryID);

    // Mark that this navigation is from a category click
    sessionStorage.setItem("isFromCategoryClick", "true");

    // Call the onClick handler from parent
    if (onClick) {
      onClick(category);
    } else {
      // Fallback navigation if onClick not provided
      window.location.href = `/shop/${category.CategoryName}/${category.ProductCategoryID}`;
    }
  };

  return (
    <Card
      hoverable
      cover={
        <img
          alt={category.CategoryName}
          src={category.CategoryImage}
          style={{
            height: 200, // Set a fixed height for the image
            width: "100%", // Ensure the image takes the full width of the card
            objectFit: "cover", // Maintain aspect ratio and crop if necessary
          }}
        />
      }
      onClick={handleCardClick}
      //   actions={[
      //     <Dropdown
      //       overlay={
      //         <Space direction="vertical">
      //           <Button type="text" block>
      //             Edit
      //           </Button>
      //           <Button type="text" block danger>
      //             Delete
      //           </Button>
      //         </Space>
      //       }
      //       trigger={["click"]}
      //     >
      //       <MoreOutlined style={{ fontSize: 18 }} />
      //     </Dropdown>,
      //   ]}
      style={{
        border:
          category.Status === "Available" ? "1px solid #52c41a" : undefined,
      }}
      actions={["View All " + category.CategoryName]}
    >
      {/* <Tag color={statusColors[category.Status]}>{category.Status}</Tag> */}
      <center>
        <h3 style={{ margin: "10px 0 4px" }}>{category.CategoryName}</h3>
      </center>
      {/* <p style={{ marginBottom: 0, color: "#888" }}>
          {product.date} | {product.category}
        </p> */}
      {/* <p style={{ fontWeight: 500 }}>{product.price}</p> */}
    </Card>
  );
};

export default ProductCategoryCard;
